import * as React from 'react';

/**
 * Sólo claims verificables. El reparto es propio y con gente estable por zona,
 * la franja horaria la elige el cliente y el pedido se sigue desde la cuenta.
 * Nada sobre antecedentes de los repartidores: no existe tal control y
 * prometerlo sería inventar.
 */
const CLAIMS = [
  {
    icon: 'fa-truck',
    title: 'Reparto propio, no una app',
    text: 'Entregamos nosotros, con repartidores estables por zona. No es alguien distinto cada vez.',
  },
  {
    icon: 'fa-calendar-check-o',
    title: 'Franja horaria elegida',
    text: 'Elegís el día y la franja. Nada de "en algún momento del día".',
  },
  {
    icon: 'fa-search',
    title: 'Seguís el pedido',
    text: 'Desde tu cuenta ves en qué estado está, sin tener que llamar a nadie.',
  },
  {
    icon: 'fa-credit-card',
    title: 'El pago lo resolvés vos',
    text: 'Pagás online con Mercado Pago o por transferencia, así nadie tiene que resolver plata en la puerta.',
  },
];

export function TrustSection() {
  return (
    <section className="sq-trust">
      <style>{`
        .sq-trust {
          padding: 72px 24px;
          background: #fafaf7;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
        }
        .sq-trust-inner {
          max-width: 1040px;
          margin: 0 auto;
        }
        .sq-trust h2 {
          font-size: 30px;
          font-weight: 800;
          color: #1a1a1a;
          text-align: center;
          margin: 0 0 12px;
        }
        .sq-trust-lead {
          font-size: 17px;
          color: #666;
          text-align: center;
          margin: 0 auto 48px;
          max-width: 640px;
          line-height: 1.6;
        }
        .sq-trust-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }
        .sq-trust-item {
          display: flex;
          gap: 16px;
          background: #fff;
          border: 1px solid #e6e6e6;
          border-radius: 12px;
          padding: 22px;
        }
        .sq-trust-item i {
          color: #1EAA25;
          font-size: 22px;
          margin-top: 2px;
          flex-shrink: 0;
          width: 26px;
          text-align: center;
        }
        .sq-trust-item h3 {
          font-size: 17px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 6px;
        }
        .sq-trust-item p {
          font-size: 15px;
          color: #555;
          line-height: 1.6;
          margin: 0;
        }
        @media (max-width: 768px) {
          .sq-trust { padding: 56px 20px; }
          .sq-trust h2 { font-size: 25px; }
          .sq-trust-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="sq-trust-inner">
        <h2>Por qué podés quedarte tranquilo</h2>
        <p className="sq-trust-lead">
          Estas son las cosas concretas que hacemos distinto. Ni una promesa que no podamos cumplir.
        </p>
        <div className="sq-trust-grid">
          {CLAIMS.map((claim) => (
            <div className="sq-trust-item" key={claim.title}>
              <i className={`fa ${claim.icon}`} />
              <div>
                <h3>{claim.title}</h3>
                <p>{claim.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
